export default __webpack_public_path__ + "static/media/minus.afb4cdc9.svg";